<template>
  <v-container>
    <v-card class="pa-4">
      <v-card-title>Калькулятор</v-card-title>
      <v-card-text>
        <v-text-field
            v-model.number="area"
            label="Площадь (м²)"
            type="number"
            min="0"
        />

        <v-select
            v-model="layers"
            :items="layerOptions"
            label="Количество слоев"
        />

        <v-select
            v-model="surfaceType"
            :items="surfaceOptions"
            label="Тип поверхности"
        />

        <v-alert v-if="calculatedAmount !== null" type="info">
          Расход материала: {{ calculatedAmount.toFixed(2) }} кг
        </v-alert>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      area: 1,
      layers: "1 слой",
      surfaceType: "Шлифованный торец",
      layerOptions: ["1 слой", "2 слоя"],
      surfaceOptions: ["Шлифованный торец", "Опиленный торец"],
    };
  },
  computed: {
    calculatedAmount() {
      if (!this.area) return null;
      let coefficient = this.layers === "1 слой" ? 0.2 : 0.325;
      return this.area * coefficient;
    },
  },
};
</script>
